import { render, staticRenderFns } from "./linkRecordInfo.vue?vue&type=template&id=00ce71da&scoped=true&"
import script from "./linkRecordInfo.vue?vue&type=script&lang=js&"
export * from "./linkRecordInfo.vue?vue&type=script&lang=js&"
import style0 from "./linkRecordInfo.vue?vue&type=style&index=0&id=00ce71da&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00ce71da",
  null
  
)

export default component.exports